import { http, HttpResponse } from "msw";
import { SystemState } from "@libs/appliance_common";
const handler = http.get("/api/sys/health", ()=>{
    const res = {
        state: SystemState.Unsealed
    };
    return HttpResponse.json(res);
});
export default handler;
